import React, {FC} from "react"

import {Deal} from "@irati/types"
import EarnPointsBadge from "@irati/ui/src/EarnPointsBadge"
import getDealCurrency from "@irati/deals/helpers/deals/currency"
import dealSavingsType from "../../constants/dealSavingsType"

import BoostedAmount from "./BoostedAmount"
import OldAmount from "./OldAmount"

import {StyledFlex} from "./styled"

interface Props {
  deal: Deal,
  isFullPage?: boolean,
  allowEarnPointsModal?: boolean,
  isMobile?: boolean
}

const BoostedSaving: FC<Props> = ({deal, isFullPage, isMobile, allowEarnPointsModal}) => {
  if (!deal?.savings) {
    return null
  }
  const {userSavings, boostedSavings} = deal.savings
  const currency = getDealCurrency(deal)
  const isCurrencySaving = userSavings?.type === dealSavingsType.CURRENCY
  return (
    <StyledFlex isFullPage={isFullPage}>
      <EarnPointsBadge deal={deal} hasModal={allowEarnPointsModal && !isMobile} />
      <BoostedAmount value={userSavings?.value} isCurrencySaving={isCurrencySaving} currency={currency} />
      {!deal.earnPoints && <OldAmount value={boostedSavings?.oldSavings?.value} isCurrencySaving={isCurrencySaving} currency={currency} />}
    </StyledFlex>
  )
}

export default BoostedSaving
